import {
  setUniqueDefExecuteQueryDataForBrands,
  setUniqueDefinitionData,
  setUniqueDefinitionDataAll,
} from "../../../features/uniqueDefSlice";
import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import { UniqueDefinitionsService } from "../../../services/api/unique-definitions.endpoints";
import store from "../../../store";

async function getInterface(oauthTokenHeader: string, setInterfaceData: any) {
  try {
    const response: any = await UniqueDefinitionsService.getInterface(
      oauthTokenHeader
    );
    if (!response.status || response.status !== 200) {
      throw new Error();
    } else {
      store.dispatch(setInterfaceData(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getDestinationTables(
  oauthTokenHeader: string,
  setDestinationTablesData: any
) {
  try {
    const response: any = await UniqueDefinitionsService.getDestinationTables(
      oauthTokenHeader
    );
    if (!response.status || response.status !== 200) {
      throw new Error();
    } else {
      store.dispatch(setDestinationTablesData(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}
async function getUnifierUniqueDefinition(
  oauthTokenHeader: string,
  selectedInterface: string | null,
  selectedDestinationTable: string | null,
  dispatch: any
) {
  if (!selectedInterface) {
    dispatch(
      setDisplayErrorSnackBar({
        message: "Please select an interface.",
        type: "error",
      })
    );
    return;
  }

  try {
    const response: any =
      await UniqueDefinitionsService.getUnifierUniqueDefinition(
        oauthTokenHeader
      );

    if (!response.status || response.status !== 200) {
      throw new Error("Failed to fetch data");
    }

    const rawData = response?.data?.data || [];

    const filtered = rawData.filter(
      (item: any) =>
        item.affiliate_system_interface === selectedInterface &&
        (!selectedDestinationTable ||
          item.destination_table === selectedDestinationTable)
    );

    dispatch(setUniqueDefinitionData(filtered));
  } catch (e: any) {
    dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getAllUnifierUniqueDefinitions(oauthTokenHeader: string) {
  try {
    const response: any =
      await UniqueDefinitionsService.getUnifierUniqueDefinition(
        oauthTokenHeader
      );
    if (!response.status || response.status !== 200) {
      throw new Error();
    } else {
      store.dispatch(setUniqueDefinitionDataAll(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}
async function getUniqueDefExecuteQuery({
  oauthTokenHeader,
  queryId,
  parameter,
  website_shared_uid,
}: {
  oauthTokenHeader: any;
  queryId: string;
  parameter: string;
  website_shared_uid: string;
}) {
  try {
    const response = await UniqueDefinitionsService.getUniqueDefExecuteQuery({
      oauthTokenHeader,
      queryId,
      parameter,
      website_shared_uid,
    });
    if (!response.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(
      setUniqueDefExecuteQueryDataForBrands(response?.data?.data || [])
    );
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText || "Failed to fetch Brands data for Unique Definition.",
        type: "error",
      })
    );
  }
}
async function createUnifierUniqueDefinition(
  oauthTokenHeader: string,
  data: any
) {
  try {
    const response =
      await UniqueDefinitionsService.createUnifierUniqueDefinition(
        oauthTokenHeader,
        data
      );
    // Ensure response exists and check for both 200 and 201
    if (!response || !response.status) {
      return { reason: "Failed to create new calculation type." };
    }

    if (response.status === 201) {
      return response;
    } else {
      return { reason: `Unexpected status code: ${response.status}` };
    }
  } catch (e: any) {
    return e?.parsedText || { reason: "Unknown error occurred." };
  }
}
async function updateUnifierUniqueDefinition(
  oauthTokenHeader: string,
  data: any,
  id: any
) {
  try {
    const response =
      await UniqueDefinitionsService.updateUnifierUniqueDefinition(
        oauthTokenHeader,
        data,
        id
      );

    if (!response || !response.status) {
      return { reason: "Failed to update unique definition." };
    }

    if (response.status === 200) {
      return response;
    } else {
      return { reason: `Unexpected status code: ${response.status}` };
    }
  } catch (e: any) {
    return e?.parsedText || { reason: "Unknown error occurred." };
  }
}
export const UniqueDefinitionsEndpointLogic = {
  getInterface,
  getDestinationTables,
  getUnifierUniqueDefinition,
  createUnifierUniqueDefinition,
  getAllUnifierUniqueDefinitions,
  updateUnifierUniqueDefinition,
  getUniqueDefExecuteQuery,
};
